export default __webpack_public_path__ + "2518dbf2fa2e3cdb7b308f02c1bee718.svg";